module.exports = __webpack_public_path__ + "static/media/agronomist_a.6418596f.svg";